<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Carnet', route: '/backoffice/carnet' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">Carnet</h1>
</section>

<section class="pb-16 mb-8 px-container">        
    <div class="row w-full flex gap-4 lg:justify-end">
        <button class="p-3 lg:w-1/6 w-full btn-outln mb-8 text-center" type="button" routerLink="/backoffice/carnet/add">                
            <i class="bi bi-plus"></i>
            Aggiungi carnet
        </button>

        <button class="p-3 lg:w-1/6 w-full btn-outln mb-8 text-center" type="button" (click)="onOpenInfo()">Gestisci info carnet</button>
    </div>
            
    <p-table #dt [loading]="loading" [value]="carnets" responsiveLayout="stack" [breakpoint]="'960px'" styleClass="p-datatable-striped" [paginator]="true" [showCurrentPageReport]="true" [rowHover]="true" [globalFilterFields]="['titoli']" currentPageReportTemplate="{first} di {last} su {totalRecords} carnet" [rows]="5" [rowsPerPageOptions]="[5, 10, 20, 50]" (onRowReorder)="onReorder($event)">            
        <ng-template pTemplate="caption">
            <div class="flex lg:flex-row flex-col justify-between items-center">
                <span class="block lg:w-1/4 w-full p-input-icon-left">
                    <i class="bi bi-search before:align-super before:content-['\f52a']"></i>
                    <input pInputText type="text" (input)="onGlobalFilter(dt, $event)" placeholder="Cerca..." class="w-full indent-6" />
                </span>
            </div>
            
        </ng-template>
        <ng-template pTemplate="header">
            <tr>        
                <th class="w-1/12"></th>            
                <th pSortableColumn="titoli" class="w-8/12">Titolo/i <span class="inline-flex"><p-sortIcon field="titoli" /></span></th>
                <th class="w-3/12 text-center">Azioni</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-carnet let-index="rowIndex">
            <tr [pReorderableRow]="index">
                <td class="text-center">
                    <i class="bi bi-list text-4xl hover:text-black" pReorderableRowHandle></i>
                </td>
                <td><span class="p-column-title">Titolo/i</span>{{carnet.titoli}}</td>
                <td class="md:justify-center justify-between flex">
                    <span class="p-column-title">Azioni</span>

                    <div class="flex flex-row items-center justify-center">                                    
                        <i class="bi bi-pencil lg:text-3xl text-2xl hover:text-accent cursor-pointer" [routerLink]="'/backoffice/carnet/' + carnet.id"></i>                        
                        <p-divider layout="vertical"></p-divider>
                        <p-confirmPopup #deleteCarnet>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">
                                        <button type="button" class="text-center btn-danger-backoffice p-2 w-full font-medium" (click)="onDeleteCarnet()">Elimina</button>
                                        <button type="button" class="text-center btn-outln-backoffice p-2 w-full font-medium"  (click)="onAnnullaDeleteCarnet()">Annulla</button>
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>

                        <i class="bi bi-trash lg:text-3xl text-2xl hover:text-accent cursor-pointer" (click)="onOpenDeleteCarnet($event, carnet)" ></i>
                    </div>                    
                </td>                    
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="3">Nessun carnet trovato.</td>
            </tr>
        </ng-template>
    </p-table>
</section>


<!-- MODAL ADD/DELETE FILE -->
<p-dialog [visible]="add_info" [style]="{width: '50%'}" header="Gestisci info carnet" [modal]="true" class="p-fluid" (visibleChange)="add_info = false">
    <ng-template pTemplate="content">

        <form [formGroup]="formInfo" (ngSubmit)="!carnet_info?.id ? onAddInfo() : onUpdateInfo()" class="flex flex-col gap-8">
            <div class="w-full">
                <p-checkbox label="Pagina carnet attiva" formControlName="attivo" value="attivo" pTooltip="Se deselezionato, il link viene nascosto da navbar e footer e la pagina non è raggiungibile" tooltipPosition="top" />
            </div>
            <div class="w-full">
                <label>* Titolo</label>
                <input type="text" pInputText formControlName="titolo" />
                <small class="text-red-600 block mt-4 font-medium" *ngIf="formInfo.get('titolo')?.hasError('required') && (formInfo.get('titolo')?.dirty || formInfo.get('titolo')?.touched)">Il titolo è obbligatorio!.</small>
            </div>
            <div class="w-full">
                <label>Descrizione</label>
                <p-editor [style]="{ height: '150px' }" formControlName="descrizione" />
            </div>
            <div class="w-full">
                <label>Link</label>
                <input type="text" pInputText formControlName="link" />
            </div>
            <div class="w-full flex lg:flex-row flex-col gap-4 justify-end">
                <button type="button" class="btn-danger-backoffice p-3 px-8 font-medium" (click)="add_info = false">Annulla</button>
                <button type="submit" class="btn-outln-backoffice p-3 px-8 font-medium" [disabled]="!formInfo.valid">{{carnet_info?.id ? 'Modifica' : 'Aggiungi'}}</button>
            </div>        
        </form>

    </ng-template>
</p-dialog>
<!-- MODAL ADD/DELETE FILE -->